/* eslint-disable max-len */
/* eslint-disable no-plusplus */
// libraries
import React from 'react';
import {
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { CheckCircle, NavigateBefore, Send } from '@material-ui/icons';
import { v4 as uuidv4 } from 'uuid';

// js
import defaultSound from '../../../assets/images/defaultSound.png';
import { allMenuItems } from './taskConstants';
import defaultPhoto from '../../../assets/images/default.png';
import {
    ContainerAdjustIconEdit,
    ContainerOptions,
    InputNullSelectedPhoto,
    Logo,
    TitleOption,
} from '../modulesStyles';

// interfaces
import type { DataModuleInterface, SelectedWordImageInterface } from '../modulesInterfaces';
import uploads from '../../../services/uploads';
import tasks from '../../../services/tasks';

const TaskSelectedWordImage = (
    setIdModal: any,
    initialDataTaskSelectedWord: SelectedWordImageInterface,
    taskSelectedWordImage: SelectedWordImageInterface,
    setTaskSelectedWordImage: any,
    dataModule: DataModuleInterface,
) => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');
    const adjustMarginBottom = { marginBottom: 10 };
    const adjustButtonLogo = { marginBottom: 25, width: 200 };
    const adjustWidthSelectedActivities = { width: 200 };
    const marginDefault = { marginRight: 10 };

    // methods
    const BackScreenModal = () => {
        setIdModal(1);
        setTaskSelectedWordImage(initialDataTaskSelectedWord);
    };

    const CreateTask = async () => {
        const formatOptions = taskSelectedWordImage?.options?.map((e: any) => {
            const option = e;
            delete option.idWrapperTask;
            return option;
        });
        const formatTask: any = {
            ...taskSelectedWordImage,
            options: formatOptions,
            idTask: taskSelectedWordImage.id,
            idModule: dataModule?.id,
        };
        delete formatTask?.id;
        if (formatTask?.idTask) {
            const editTask: any = await tasks.EditTask(formatTask, token);
            if (editTask) {
                BackScreenModal();
            }
        } else {
            delete formatTask?.idTask;
            const createTask: any = await tasks.CreateTask(formatTask, token);
            if (createTask) {
                BackScreenModal();
            }
        }
    };

    const onChangeTitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordImage, title: txt.target.value };
            setTaskSelectedWordImage(newDataTask);
        }
    };

    const onChangeSubtitle = (txt: any) => {
        if (txt.target.value.length <= 200) {
            const newDataTask = { ...taskSelectedWordImage, subtitle: txt.target.value };
            setTaskSelectedWordImage(newDataTask);
        }
    };

    const onChangeOptionSkipTask = (txt: any) => {
        const newDataTask = { ...taskSelectedWordImage, skip: txt.target.value };
        setTaskSelectedWordImage(newDataTask);
    };

    const validationDisabled = () => {
        let valueObject = true;
        if (taskSelectedWordImage?.id) {
            const ValidationLength = Object.values(taskSelectedWordImage).filter((v) => v !== '').length !== 10;
            const ValidationOptionsLength = taskSelectedWordImage?.options.filter((v: any) => v.option).length === taskSelectedWordImage?.options?.length;
            if (!ValidationLength && ValidationOptionsLength) {
                valueObject = false;
            }
        } else if (!taskSelectedWordImage?.id) {
            const ValidationLength = Object.values(taskSelectedWordImage).filter((v) => v !== '').length !== 9;
            if (!ValidationLength) {
                valueObject = false;
            }
        }
        return valueObject;
    };

    const validationBackground = () => {
        const valueObject = Object.values(taskSelectedWordImage).filter((v) => v !== '');
        const ValidationOptionsLength = taskSelectedWordImage?.options.filter((v: any) => v.option).length === taskSelectedWordImage?.options?.length;
        if ((taskSelectedWordImage?.id ? valueObject.length === 10 : valueObject.length === 9) && ValidationOptionsLength) {
            return 'primary';
        }

        return 'inherit';
    };

    const onChangeTarget = (txt: any) => {
        const allOptions = [];
        for (let i = 0; i < Number(txt.target.value); i++) {
            const objOrigin = {
                option: '',
                id: uuidv4(),
            };
            allOptions.push(objOrigin);
            if (allOptions.length === Number(txt.target.value)) {
                const orderNewDataOption = allOptions.sort((a, b) => {
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    return 0;
                });
                const newDataTask = {
                    ...taskSelectedWordImage,
                    target: Number(txt.target.value),
                    options: orderNewDataOption,
                    correct: orderNewDataOption.filter((v: any) => !v.option).length > 0 ? '' : taskSelectedWordImage?.correct,
                };
                setTaskSelectedWordImage(newDataTask);
            }
        }
    };

    const onChangeOptionCorrect = (txt: any) => {
        const newDataTask = { ...taskSelectedWordImage, correct: txt.target.value };
        setTaskSelectedWordImage(newDataTask);
    };

    // renders
    const RenderAllOptionsCorrect = () => {
        const AllOptionsEnglish = [] as any;
        const test = taskSelectedWordImage.options.map(
            (v: any) => AllOptionsEnglish.push(v.option),
        );
        if (AllOptionsEnglish.length === test.length) {
            return AllOptionsEnglish.map((option: any) => (
                <MenuItem value={option}>{option}</MenuItem>
            ));
        }

        return null;
    };

    const RenderSelectedCorrectOptions = (skipTask: boolean) => {
        const optionsLength = taskSelectedWordImage.options.filter((v: any) => v.option !== '').length;
        const allOptions = optionsLength === taskSelectedWordImage.target;

        if (optionsLength > 0 && allOptions && !skipTask) {
            const SelectedPhotoArchive = async (event: any, key: string) => {
                if (event.target.files.length) {
                    const newDataFiles = {
                        eventFile: event.target.files[0],
                        eventName: event.target.files[0].name,
                        file: URL.createObjectURL(event.target.files[0]),
                    };

                    const upload: any = await uploads.UploadFile(newDataFiles.eventFile);
                    if (upload) {
                        setTaskSelectedWordImage({ ...taskSelectedWordImage, [key]: upload.result });
                    }
                    // eslint-disable-next-line no-param-reassign
                    event.target.value = null;
                }
            };

            return (
                <>
                    <FormControl style={adjustWidthSelectedActivities}>
                        <InputLabel>Opção correta</InputLabel>
                        <Select value={taskSelectedWordImage.correct} onChange={onChangeOptionCorrect}>
                            {RenderAllOptionsCorrect()}
                        </Select>
                    </FormControl>
                    <Button
                        style={adjustButtonLogo}
                        title={taskSelectedWordImage?.file}
                    >
                        <Logo src={defaultSound} />
                        {taskSelectedWordImage?.file ? (
                            <ContainerAdjustIconEdit right="40px" style={adjustMarginBottom}>
                                <CheckCircle color="inherit" />
                            </ContainerAdjustIconEdit>
                        ) : null}
                        <InputNullSelectedPhoto
                            accept=".mp3,audio/*"
                            onChange={(event) => SelectedPhotoArchive(event, 'file')}
                            type="file"
                        />
                    </Button>
                    <Button
                        style={adjustButtonLogo}
                        title={taskSelectedWordImage?.fileImg}
                    >
                        <Logo src={taskSelectedWordImage?.fileImg || defaultPhoto} />
                        <InputNullSelectedPhoto
                            accept="image/png, image/jpeg, image/jpg"
                            onChange={(event) => SelectedPhotoArchive(event, 'fileImg')}
                            type="file"
                        />
                    </Button>
                </>
            );
        }
        if (optionsLength > 0 && allOptions && skipTask) {
            return (
                <FormControl style={adjustWidthSelectedActivities}>
                    <InputLabel>Pular/Não pular</InputLabel>
                    <Select value={taskSelectedWordImage.skip} onChange={onChangeOptionSkipTask}>
                        <MenuItem value="true">Pular</MenuItem>
                        <MenuItem value="false">Não pular</MenuItem>
                    </Select>
                </FormControl>
            );
        }

        return null;
    };

    const RenderInputsOptions = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <TextField
                fullWidth
                label={`${label} (${ValueActual.length}/50)`}
                onChange={onChange}
                style={marginDefault}
                value={value}
            />
        );
    };

    const RenderInputsTitles = (label: string, value: string, onChange: any) => {
        const ValueActual = value;
        return (
            <>
                <ContainerOptions marginTop="10px" />
                <TextField
                    fullWidth
                    label={`${label} (${ValueActual.length}/200)`}
                    onChange={onChange}
                    value={value}
                />
            </>
        );
    };

    const RenderInputsBody = () => {
        if (taskSelectedWordImage.options?.length) {
            return taskSelectedWordImage.options.map((item: any, index: number) => {
                const indexFormat = index + 1;
                const indexZero = indexFormat < 10 ? 0 : '';

                const onChangeOptionPortuguese = (txt: any) => {
                    if (txt.target.value.length <= 50) {
                        const [getOneOption] = taskSelectedWordImage.options.filter(
                            (v: any) => v.id === item.id,
                        );
                        if (getOneOption.id === item.id) {
                            const removeOneOption = taskSelectedWordImage.options.filter(
                                (v: any) => v.id !== item.id,
                            );
                            const optionModified = {
                                option: txt.target.value,
                                id: getOneOption.id,
                            };
                            const newDataOption = [...removeOneOption, optionModified];
                            const orderNewDataOption = newDataOption.sort((a, b) => {
                                if (a.id < b.id) return -1;
                                if (a.id > b.id) return 1;
                                return 0;
                            });
                            setTaskSelectedWordImage({
                                ...taskSelectedWordImage,
                                options: orderNewDataOption,
                            });
                        }
                    }
                };

                return (
                    <ContainerOptions marginTop="10px">
                        {RenderInputsOptions(`Opção ${indexZero}${indexFormat}`, item.option, onChangeOptionPortuguese)}
                    </ContainerOptions>
                );
            });
        }

        return null;
    };

    const RenderAllItems = () => {
        if (allMenuItems.ids.length) {
            return allMenuItems.ids.map((idSelected: any) => (
                <MenuItem value={idSelected}>{idSelected}</MenuItem>
            ));
        }
        return null;
    };

    const EndIcon = () => (
        <Send />
    );

    const RenderIconGoBack = () => (
        <NavigateBefore />
    );

    return (
        <>
            <ContainerOptions>
                <TitleOption width="100%">Criação da Atividade - Associe a imagem às palavras</TitleOption>
            </ContainerOptions>
            {RenderInputsTitles('Título da atividade', taskSelectedWordImage.title, onChangeTitle)}
            {RenderInputsTitles('Subtítulo da atividade', taskSelectedWordImage.subtitle, onChangeSubtitle)}
            <FormControl style={adjustWidthSelectedActivities}>
                <InputLabel>Quantidade</InputLabel>
                <Select value={taskSelectedWordImage.target} onChange={onChangeTarget}>
                    {RenderAllItems()}
                </Select>
            </FormControl>
            {RenderInputsBody()}
            <ContainerOptions marginTop="10px" width="80%">
                {RenderSelectedCorrectOptions(false)}
                {RenderSelectedCorrectOptions(true)}
            </ContainerOptions>
            <ContainerOptions marginTop="40px">
                <Button
                    color="primary"
                    startIcon={RenderIconGoBack()}
                    onClick={BackScreenModal}
                    variant="contained"
                >
                    Voltar
                </Button>
                <Button
                    color={validationBackground()}
                    disabled={validationDisabled()}
                    endIcon={EndIcon()}
                    onClick={CreateTask}
                    variant="contained"
                >
                    {taskSelectedWordImage?.id ? 'Editar Atividade' : 'Criar Atividade'}
                </Button>
            </ContainerOptions>
        </>
    );
};

export default TaskSelectedWordImage;
